import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
// import { auth } from '../../helpers/Firebase';
import {
  LOGIN_USER,
  REGISTER_USER,
  LOGOUT_USER,
  FORGOT_PASSWORD,
  RESET_PASSWORD,
} from '../actions';

import {
  loginUserSuccess,
  // loginUserError,
  // registerUserSuccess,
  // registerUserError,
  // forgotPasswordSuccess,
  // forgotPasswordError,
  // resetPasswordSuccess,
  // resetPasswordError,
} from './actions';

import { adminRoot } from "../../constants/defaultValues"
import { setCurrentUser } from '../../helpers/Utils';
import {  UserRole } from '../../helpers/authHelper';

export function* watchLoginUser() {
  yield takeEvery(LOGIN_USER, loginWithEmailPassword);
}

// const loginWithEmailPasswordAsync = async (email, password) =>
//   await auth
//     .signInWithEmailAndPassword(email, password)
//     .then((user) => user)
//     .catch((error) => error);

function* loginWithEmailPassword({ payload }) {
  //const { email, password } = payload.user;
  const { history } = payload;
  // try {
  //   const loginUser = yield call(loginWithEmailPasswordAsync, email, password);
  //   if (!loginUser.message) {
  //     console.log("Login Success", item);
  //     const item = { uid: loginUser.user.uid, ...currentUser };
  //     setCurrentUser(item);
  //     yield put(loginUserSuccess(item));
  //     history.push(adminRoot);
  //   } else {
  //     console.log("Login Error", loginUser.message);
  //     yield put(loginUserError(loginUser.message));
  //   }
  // } catch (error) {
  //   console.log("Login Fail", error);
  //   yield put(loginUserError(error));
  // }
  // console.log("L ", payload);
  console.log("L ", payload);
  
  if (payload.user.email === 'ssec') {
    const currentUser = { userCode: 1, title: '(주)신성일렉콤', img: '/assets/users/ssec.png',    date: '15:24', role: UserRole.Admin}
    const item = { uid: 'abfad35d3234', ...currentUser};
    setCurrentUser(item);
    yield put(loginUserSuccess(item));
  
  } else if (payload.user.email === 'lte') {
    const currentUser = { userCode: 3, title: 'lte테스트', img: '/assets/users/nwgu.png',    date: '15:24', role: UserRole.Admin}
    const item = { uid: 'abcwa23gf1g234', ...currentUser};
    setCurrentUser(item);
    yield put(loginUserSuccess(item));
  // } else if (payload.user.email === 'dscorp') {
  //   const currentUser = { userCode: 2, title: '동선기업', img: '/assets/users/snsi.png',    date: '15:24', role: UserRole.Admin}
  //   const item = { uid: 'abcw12gf1g234', ...currentUser};
  //   setCurrentUser(item);
  //   yield put(loginUserSuccess(item));
  // } else if (payload.user.email === 'snsi') {
  //   const currentUser = { userCode: 200, title: '성남시청', img: '/assets/users/snsi.png',    date: '15:24', role: UserRole.User}
  //   const item = { uid: 'aba3t1dc34', ...currentUser};
  //   setCurrentUser(item);
  //   yield put(loginUserSuccess(item));
  } else if (payload.user.email === 'gwjsi') {
    const currentUser = { userCode: 200, title: '광주시청', img: '/assets/users/gwangju.png',    date: '15:24', role: UserRole.User}
    const item = { uid: 'aba3t1dc34', ...currentUser};
    setCurrentUser(item);
    yield put(loginUserSuccess(item));
  } else if (payload.user.email == 'bdgu') {
    const currentUser = { userCode: 201, title: '분당구청', img: '/assets/users/snsi.png',    date: '15:24', role: UserRole.User}
    const item = { uid: 'aba3t9dc34', ...currentUser};
    setCurrentUser(item);
    yield put(loginUserSuccess(item));
   
  } else if (payload.user.email === 'jwgu') {
    const currentUser = { userCode: 203, title: '중원구청', img: '/assets/users/snsi.png',    date: '15:24', role: UserRole.User}
    const item = { uid: 'abc28145234', ...currentUser};
    setCurrentUser(item);
    yield put(loginUserSuccess(item));
   
  } else if (payload.user.email === 'sjgu') {
    const currentUser = { userCode: 204, title: '수정구청', img: '/assets/users/snsi.png',    date: '15:24', role: UserRole.User}
    const item = { uid: 'abc72145234', ...currentUser};
    setCurrentUser(item);
    yield put(loginUserSuccess(item));
   
  } else if (payload.user.email === 'nyj') {
    const currentUser = { userCode: 220, title: '남양주시청', img: '/assets/users/nyjsi.png',    date: '15:24', role: UserRole.User}
    const item = { uid: 'ab5zzch234', ...currentUser};
    setCurrentUser(item);
    yield put(loginUserSuccess(item));
  } else if (payload.user.email === 'yjsi') {
    const currentUser = { userCode: 225, title: '여주시청', img: '/assets/users/yeojusi.png',    date: '15:24', role: UserRole.User}
    const item = { uid: 'a6bzzch234', ...currentUser};
    setCurrentUser(item);
    yield put(loginUserSuccess(item));
  } else if (payload.user.email === 'ghgun') {
    const currentUser = { userCode: 311, title: '고흥군청', img: '/assets/users/ghgun.png',    date: '15:24', role: UserRole.User}
    const item = { uid: 'abzzch5234', ...currentUser};
    setCurrentUser(item);
    yield put(loginUserSuccess(item));
  // } else if (payload.user.email === 'wsgu') {
  //   const currentUser = { userCode: 312, title: '완산구청', img: '/assets/users/jeonju.png',    date: '15:24', role: UserRole.User}
  //   const item = { uid: 'abzzc4h234', ...currentUser};
  //   setCurrentUser(item);
  //   yield put(loginUserSuccess(item));
  // } else if (payload.user.email === 'djgu') {
  //   const currentUser = { userCode: 313, title: '덕진구청', img: '/assets/users/jeonju.png',    date: '15:24', role: UserRole.User}
  //   const item = { uid: 'abzz3ch234', ...currentUser};
  //   setCurrentUser(item);
  //   yield put(loginUserSuccess(item));
  } else if (payload.user.email === 'hps') {
    const currentUser = { userCode: 111, title: '호평동 문화체육팀', img: '/assets/users/nyjsi.png',    date: '15:24', role: UserRole.User}
    const item = { uid: 'abz2zch234', ...currentUser};
    setCurrentUser(item);
    yield put(loginUserSuccess(item));
  
  } else if (payload.user.email === 'gangdong') {
    const currentUser = { userCode: 112, title: '강동구청', img: '/assets/users/gangdong.png',    date: '15:24', role: UserRole.User}
    const item = { uid: 'ab1zzch234', ...currentUser};
    setCurrentUser(item);
    yield put(loginUserSuccess(item));
  } 

  history.push(adminRoot);
  

}

export function* watchRegisterUser() {
  yield takeEvery(REGISTER_USER, registerWithEmailPassword);
}

// const registerWithEmailPasswordAsync = async (email, password) =>
//   await auth
//     .createUserWithEmailAndPassword(email, password)
//     .then((user) => user)
//     .catch((error) => error);

function* registerWithEmailPassword({ payload }) {
  // const { email, password } = payload.user;
  // const { history } = payload;
  // try {
  //   const registerUser = yield call(
  //     registerWithEmailPasswordAsync,
  //     email,
  //     password
  //   );
  //   if (!registerUser.message) {
  //     const item = { uid: registerUser.user.uid, ...currentUser };
  //     setCurrentUser(item);
  //     yield put(registerUserSuccess(item));
  //     history.push(adminRoot);
  //   } else {
  //     yield put(registerUserError(registerUser.message));
  //   }
  // } catch (error) {
  //   yield put(registerUserError(error));
  // }
}

export function* watchLogoutUser() {
  yield takeEvery(LOGOUT_USER, logout);
}

// const logoutAsync = async (history) => {
//   await auth
//     .signOut()
//     .then((user) => user)
//     .catch((error) => error);
//   history.push(adminRoot);
// };

function* logout({ payload }) {
  const { history } = payload;
  setCurrentUser();
  // yield call(logoutAsync, history);
}

export function* watchForgotPassword() {
  yield takeEvery(FORGOT_PASSWORD, forgotPassword);
}

// const forgotPasswordAsync = async (email) => {
//   return await auth
//     .sendPasswordResetEmail(email)
//     .then((user) => user)
//     .catch((error) => error);
// };

function* forgotPassword({ payload }) {
  // const { email } = payload.forgotUserMail;
  // try {
  //   const forgotPasswordStatus = yield call(forgotPasswordAsync, email);
  //   if (!forgotPasswordStatus) {
  //     yield put(forgotPasswordSuccess('success'));
  //   } else {
  //     yield put(forgotPasswordError(forgotPasswordStatus.message));
  //   }
  // } catch (error) {
  //   yield put(forgotPasswordError(error));
  // }
}

export function* watchResetPassword() {
  yield takeEvery(RESET_PASSWORD, resetPassword);
}

const resetPasswordAsync = async (resetPasswordCode, newPassword) => {
  // return await auth
  //   .confirmPasswordReset(resetPasswordCode, newPassword)
  //   .then((user) => user)
  //   .catch((error) => error);
};

function* resetPassword({ payload }) {
  // const { newPassword, resetPasswordCode } = payload;
  // try {
  //   const resetPasswordStatus = yield call(
  //     resetPasswordAsync,
  //     resetPasswordCode,
  //     newPassword
  //   );
  //   if (!resetPasswordStatus) {
  //     yield put(resetPasswordSuccess('success'));
  //   } else {
  //     yield put(resetPasswordError(resetPasswordStatus.message));
  //   }
  // } catch (error) {
  //   yield put(resetPasswordError(error));
  // }
}

export default function* rootSaga() {
  yield all([
    fork(watchLoginUser),
    fork(watchLogoutUser),
    fork(watchRegisterUser),
    fork(watchForgotPassword),
    fork(watchResetPassword),
  ]);
}
